// @flow

import xss from 'xss'

import {
  replaceBold,
  replaceCollapsible,
  replaceItalic,
  replaceLineBreaks,
  replaceLink,
  replaceSmall
} from './markup'

const xssOptions = {
  whiteList: {
    span: ['class'],
    b: [],
    i: [],
    br: [],
    a: ['target', 'href', 'title'],
    strong: [],
    small: [],
    // custom tags for markup
    collapsible: ['title']
  }
}

export function sanitizedText (text: string): string {
  return xss(text, xssOptions)
}

export function sanitizedMarkup (text: string, messageId?: number): string {
  return replaceLineBreaks(
    replaceCollapsible(
      replaceSmall(
        replaceItalic(
          replaceBold(
            replaceLink(
              sanitizedText(text)
              , messageId
            )
          )
        )
      )
    )
  )
}
